import { useAppSelector } from "hooks/reduxHooks";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
export const useFilterCriteria = () => {
  // Access Redux state values
  const industryData = useSelector((state: RootState) => state.filtercriteria.industryData);
  const allCompanies = useSelector((state: RootState) => state.filtercriteria.allCompanies);
  const industryLeaderData = useSelector((state: RootState) => state.filtercriteria.industryLeaderData);
  const jobTitlesData = useSelector((state: RootState) => state.filtercriteria.jobTitlesData);
  const locationsData = useSelector((state: RootState) => state.filtercriteria.locationsData);
  const excludeLocationsData = useSelector((state: RootState) => state.filtercriteria.excludeLocationsData);
  const universitiesData = useSelector((state: RootState) => state.filtercriteria.universitiesData);
  const keywordsData = useSelector((state: RootState) => state.filtercriteria.keywordsData);
  const skillsData = useSelector((state: RootState) => state.filtercriteria.skillsData);
  const minExp = useSelector((state: RootState) => state.filtercriteria.minExp);
  const maxExp = useSelector((state: RootState) => state.filtercriteria.maxExp);
  const startYear = useSelector((state: RootState) => state.filtercriteria.startYear);
  const endYear = useSelector((state: RootState) => state.filtercriteria.endYear);
  const {
    manual_import,
    extension_import,
    db,
    ats
  } = useAppSelector((state) => state.filtercriteria);

  const { search_only_greenhouse_mckinney, search_only_lever_ss } = useAppSelector(
    (state) => state.filtercriteria
  );
  // Build the filter criteria array
  return [
    {
      field_to_filter: "industry",
      filter_value: industryData,
      name: "Industry",
    },
    {
      field_to_filter: "all_companies",
      filter_value: allCompanies,
      name: "Companies",
    },
    {
      field_to_filter: "titles",
      filter_value: jobTitlesData,
      name: "Job Titles",
    },
    {
      field_to_filter: "location",
      filter_value: locationsData,
      name: "Locations",
    },
    {
      field_to_filter: "locations_exclude",
      filter_value: excludeLocationsData,
      name: "Excluded Locations",
    },
    {
      field_to_filter: "education_experience",
      filter_value: universitiesData || [],
      name: "School Attended",
    },
    {
      field_to_filter: "db",
      filter_value: db ? ["true"] : [],
      name: "DB",
    },
    {
      field_to_filter: "manual_import",
      filter_value: manual_import ? ["true"] : [],
      name: "Manual Import",
    },
    {
      field_to_filter: "extension_import",
      filter_value: extension_import ? ["true"] : [],
      name: "Extension Import",
    },
    {
      field_to_filter: "ats",
      filter_value: ats ? ["true"] : [],
      name: "ATS",
    },
    // {
    //   field_to_filter: "search_only_greenhouse_mckinney",
    //   filter_value: search_only_greenhouse_mckinney || false,
    //   name: "Green House",
    // },
    // {
    //   field_to_filter: "search_only_lever_ss",
    //   filter_value: search_only_lever_ss || false,
    //   name: "Lever",
    // },
    {
      field_to_filter: "keyword",
      filter_value: keywordsData,
      name: "Profile Keywords",
    },
    {
      field_to_filter: "skills",
      filter_value: skillsData,
      name: "Skills and Assessments",
    },
    {
      field_to_filter: "total_experience",
      min_exp: minExp,
      max_exp: maxExp,
      name: "Years of Experience",
    },
    {
      field_to_filter: "year_of_graduation",
      start_year: startYear,
      end_year: endYear,
      name: "Graduation Year",
    },
  ];
};
